import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, TINY_MARGIN } from '../../../theme';

const useStyles = (bgColor = colorsPalette.blue, textColor = colorsPalette.white, textMaxWidth) =>
  makeStyles((theme: Theme) =>
    createStyles({
      categoryLabel: {
        borderRadius: 5,
        background: bgColor,
        padding: '4px 9px 5px',
        display: 'inline-flex',
        alignItems: 'center',
      },
      categoryTitle: {
        color: textColor,
        fontWeight: 'bold',
        fontSize: 14,
        lineHeight: 1.4,
      },
      withDots: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 100,
        [theme.breakpoints.up('md')]: {
          maxWidth: textMaxWidth || 125,
        },
      },
      icon: {
        width: 16,
        height: 16,
        marginRight: TINY_MARGIN,
        marginTop: 2,
      },
    }),
  );

export default useStyles;
